import { Button, Popover, PopoverContent, PopoverTrigger } from '@monksflow/monks-ui';
import { ChevronDownIcon, InfoIcon } from 'lucide-react';
import { ChatOptionDropdown } from '../ChatOptionDropdown/ChatOptionDropdown';
import { NoModelsPanel } from './NoModelsPanel';
import { DropdownSelectProps } from '@/shared/ui/DropdownSelect/DropdownSelect';
import { useTranslation } from 'react-i18next';

/**
 * Specialized dropdown component for AI model selection.
 * Handles the empty state when no models are available due to whitelist restrictions.
 * Falls back to normal ChatOptionDropdown when models are available.
 */
export const ModelsDropdown = <T extends string | number>(props: DropdownSelectProps<T>) => {
  const { t } = useTranslation('chats');

  const hasOptions = props.options.length > 0;

  // Normal dropdown behavior when models exist
  if (hasOptions) {
    return <ChatOptionDropdown {...props} />;
  }

  return (
    <div className="relative">
      <Popover>
        <PopoverTrigger asChild>
          <Button
            type="button"
            variant="outline"
            className="w-full min-w-auto justify-between font-normal text-muted-foreground"
          >
            <InfoIcon className="size-4.5 text-warning-foreground" />
            {t('chats.modelsDropdown.noModel')}
            <ChevronDownIcon className="size-4.5" />
          </Button>
        </PopoverTrigger>

        <PopoverContent align="start" side="top" className="w-75 p-0">
          <NoModelsPanel />
        </PopoverContent>
      </Popover>
    </div>
  );
};
